<div [ngClass]="loading ? 'visually-hidden': ''">
  <div class="overlay" *ngIf="showOverlay"></div>
  <div class="mb-2">
    <div class="flex-item " [ngClass]="!foldersVisible ? 'notMobile': 'visually-hidden'">
      <p-button icon="fas fa-chevron-right" pTooltip="Show Folders" tooltipPosition="top" (click)="toggleFolderView();"
        styleClass="p-button-text p-button-raised text-primary"></p-button>
    </div>
    <div class="flex-item" [ngClass]="!foldersVisible ? 'forMobile': 'visually-hidden'">
      <p-button icon="fas fa-chevron-down" pTooltip="Show Folders" tooltipPosition="top" (click)="toggleFolderView();"
        styleClass="p-button-text p-button-raised text-primary"></p-button>
    </div>
  </div>
  <div class="row">
    <div id="leftContent" [ngClass]="foldersVisible ? 'col-3' : 'visually-hidden'" class="notMobile mb-2">
      <span>
        <div [class.invisible]="!foldersVisible">
          <div class="d-flex justify-content-between">
            <div class="flex-item section-header">&nbsp;</div>
            <div class="flex-item">
              <a class="text-primary notMobile" (click)="toggleFolderView();" pTooltip="Hide Filters"
                tooltipPosition="top"><i class="fas fa-chevron-left"></i></a>
              <a class="text-primary forMobile" (click)="toggleFolderView();" pTooltip="Hide Filters"
                tooltipPosition="left"><i class="fas fa-chevron-right"></i></a>
            </div>
          </div>
          <app-nav-left></app-nav-left>
          <app-folder-view [foldersData]="folders"></app-folder-view>
          <!-- (onSelectNode)="loadSelectedFolder($event);" -->
        </div>
      </span>
    </div>
    <!-- Empty View-->
    <div *ngIf="viewItems.length <= 0" [ngClass]="foldersVisible ? 'col-9' : ' ps-3'">
      <div class="notMobile">
        <p-panel class="p-fluid mt-2 results">
          <ng-template pTemplate="header">
            <div class="container notMobile">
              <div class="d-flex justify-content-between">
                <div class="flex-item mt-2 mb-2">
                  <span *ngIf="documentLibraryTitle == constants.indexEHD"
                    class="section-header notMobile">{{constants.display_Name_EHD}}</span>
                  <span *ngIf="documentLibraryTitle == constants.indexSDM"
                    class="section-header notMobile">{{constants.display_Name_SDM}}</span>
                  <!-- <span class="section-header notMobile">{{documentLibraryTitle}}</span> -->
                  <span class="forMobile">Documents</span>
                </div>
              </div>
            </div>
          </ng-template>
          <!-- Bread Crumbs-->
          <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
          <app-folder-empty-view [folderSelected]="isFolderSelected"></app-folder-empty-view>
        </p-panel>
      </div>
    </div>
    <!-- Content View -->
    <div *ngIf="viewItems.length > 0" [ngClass]="foldersVisible ? 'col-9' : ' ps-3'">
      <div class="notMobile">

        <div id="results-top"></div>
        <!-- <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
          [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
          (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions> -->
        <p-panel class="p-fluid mt-2 results">
          <ng-template pTemplate="header">
            <div class="container notMobile">
              <div class="d-flex justify-content-between">
                <div class="flex-item mt-2 mb-2">
                  <span class="section-header notMobile">{{documentLibraryTitle}}</span>
                  <span class="forMobile">Results</span>
                </div>
                <div class="flex-item mt-2 mb-2">
                  <span *ngIf="currentView == 'table'">
                    <button type="button" class="btn btn-secondary btn-sm me-2" (click)="showCreateReport();"><i
                        class="fa fa-file-excel notMobile"></i>
                      Report</button>
                    <button type="button" class="btn btn-secondary btn-sm me-2" (click)="showDownloadDocs();"><i
                        class="fa fa-file-arrow-down notMobile"></i> Download
                    </button>
                    <p-overlayPanel #columnsop>
                      <app-columns-select-panel [cols]="columnsSvc.cols" (columnsChangedEvent)="updateCols($event);">
                      </app-columns-select-panel>
                    </p-overlayPanel>
                    <button type="button" class="btn btn-secondary btn-sm me-2" (click)="columnsop.toggle($event);"><i
                        class="fas fa-table-columns notMobile"></i>
                      Columns</button>
                    <p-overlayPanel #sortop>
                      <app-sort-select-panel (executeSort)="sortItems($event);"
                        (executeSortReset)="resetSort();"></app-sort-select-panel>
                    </p-overlayPanel>
                    <button type="button" class="btn btn-secondary btn-sm me-2" (click)="sortop.toggle($event);"><i
                        class="fas fa-sort notMobile"></i>
                      Sort</button>
                  </span>

                </div>
              </div>
            </div>
          </ng-template>
          <p-scrollTop styleClass="scrolltop-location custom-scrolltop" buttonAriaLabel="Scroll To Top"></p-scrollTop>
          <!-- Bread Crumbs-->
          <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHomeItem"
            (onItemClick)="$event.item.command"></p-breadcrumb>
          <!-- <app-folder-sub-list></app-folder-sub-list> -->
          <!-- Sub Folder listing -->
          <app-folder-sub-list></app-folder-sub-list>

          <!-- Hide Package Contents checkbox -->
          <div class="max-w-full pt-2 pb-1 px-2" style="border-bottom: 1px solid #f5f5f5;">
            <p-toggleswitch [(ngModel)]="hidePackageContents" (onChange)="togglePackageContents($event)"
              id="pacakgeContents" pTooltip="Hide Package Contents" tooltipPosition="right" />
          </div>
          <!-- Results Table View -->
          <div>
            <app-results-table-view [loading]="loading" [viewItems]="viewItems" [totalCount]="totalCount"
              (docDetails)="showDocDetails($event)" (shareLink)="showShareDialog($event)"
              (addNewCols)="updateCols($event)">
            </app-results-table-view>
          </div>
        </p-panel>
        <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
          [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
          (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions>
      </div>
    </div>

    <div [ngClass]="foldersVisible ? 'col-12  p-2': ' '" class="forMobile">
      <div class="flex-item forMobile pb-3" *ngIf="foldersVisible">
        <p-button icon="fas fa-chevron-up" pTooltip="Hide Folders" tooltipPosition="top" (click)="toggleFolderView();"
          styleClass="p-button-text p-button-raised text-primary"></p-button>
        <app-nav-left></app-nav-left>
        <app-folder-view [foldersData]="folders"></app-folder-view>
      </div>
      <div class="flex-item forMobile pb-3" *ngIf="!foldersVisible">
      </div>
    </div>

    <div [ngClass]="foldersVisible ? 'col-12 ps-2' : ' ps-3'" class="forMobile">
      <!-- Bread Crumbs-->
      <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
      <div class="max-w-full pt-2 pb-1 px-2" style="border-bottom: 1px solid #f5f5f5;">
        <p-toggleswitch [(ngModel)]="hidePackageContents" (onChange)="togglePackageContents($event)"
          id="pacakgeContents" pTooltip="Hide Package Contents" tooltipPosition="right" />
      </div>
      <p-panel class="p-fluid mt-2 results">
        <ng-template pTemplate="header">
          <div class="container forMobile">
            <div>
              <div class="mt-2 mb-2" style="display: block;">
                <span>Results</span>
              </div>
              <div class="mb-2" style="display: block;text-align: center;">
                <span *ngIf="currentView === 'summary'">
                  <button type="button" class="btn btn-secondary btn-sm me-2"
                    (click)="toggleView(constants.results_view_table);">
                    <i class="fas fa-table notMobile"></i> Table View</button>
                </span>
                <span *ngIf="currentView == 'table'">
                  <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                    (click)="toggleView(constants.results_view_summary);"><i class="fas fa-list notMobile"></i>Summary
                    View</button>
                  <button type="button" class="btn btn-secondary btn-sm me-2 mt-2" (click)="showCreateReport();"><i
                      class="fa fa-file-excel notMobile"></i>
                    Report</button>
                  <button type="button" class="btn btn-secondary btn-sm me-2 mt-2" (click)="showDownloadDocs();"><i
                      class="fa fa-file-arrow-down notMobile"></i> Download
                  </button>
                  <p-overlayPanel #columnsop>
                    <app-columns-select-panel [cols]="columnsSvc.cols" (columnsChangedEvent)="updateCols($event);">
                    </app-columns-select-panel>
                  </p-overlayPanel>
                  <button type="button" class="btn btn-secondary btn-sm me-2 mt-2"
                    (click)="columnsop.toggle($event);"><i class="fas fa-table-columns notMobile"></i>
                    Columns</button>
                  <p-overlayPanel #sortop>
                    <app-sort-select-panel (executeSort)="sortItems($event);"
                      (executeSortReset)="resetSort();"></app-sort-select-panel>
                  </p-overlayPanel>
                  <button type="button" class="btn btn-secondary btn-sm me-2 mt-2" (click)="sortop.toggle($event);"><i
                      class="fas fa-sort notMobile"></i>
                    Sort</button>
                </span>

              </div>
            </div>

          </div>
        </ng-template>
        <div *ngIf="viewItems.length <= 0">
          <app-folder-empty-view [folderSelected]="isFolderSelected"></app-folder-empty-view>
        </div>
        <p-scrollTop styleClass="scrolltop-location custom-scrolltop" buttonAriaLabel="Scroll To Top"></p-scrollTop>

        <div *ngIf="currentView==='table'">
          <app-results-table-view [loading]="loading" [viewItems]="viewItems" [totalCount]="totalCount"
            (docDetails)="showDocDetails($event)" (shareLink)="showShareDialog($event)"
            (addNewCols)="updateCols($event)">
          </app-results-table-view>
        </div>
      </p-panel>
      <app-results-actions [total]="totalCount" [first]="first" [query]="qs" [currentView]="currentView"
        [routeLink]="routeLink" (onPageChange)="paginate($event)" [pageSize]="pageSize"
        (onToggleFacets)="toggleFacets($event)" (changeView)="toggleView($event)"></app-results-actions>
    </div>
  </div>
</div>
<app-reports-dialog [createReportVisible]="showReportDialog" (closeDialog)="hideReports();"
  (executeDownload)="downloadSelected($event);"></app-reports-dialog>
<app-download-dialog [downloadVisible]="showDownloadDialog" (closeDialog)="hideDownloadDocs();"></app-download-dialog>
<p-toast key="columnAdded" position="top-left"></p-toast>
<!-- Report Download Progress Bar and Cancel Toast -->
<p-dialog header="Downloading {{reportType}} Report" [(visible)]="isDownloading" [style]="{width:'30vw'}"
  (onHide)="executeCancelDownload();">
  <p-progressBar [value]="progress"></p-progressBar>
</p-dialog>
<p-toast key="csvcancel"></p-toast>
<p-toast key="downloadFiles" position="bottom-left"></p-toast>